import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { MensagemUsuario } from '../../models/chat-bot.model';
import { ActionTable, ColumnsTable } from 'src/app/shared/models/table.model';
import { FilterTable } from 'src/app/shared/models/filter.model';
import { SuporteGeralService } from '../../services/suporte-geral.service';
import { ActivatedRoute } from '@angular/router';
import { Ativo } from 'src/app/shared/models/enumerations.model';

@Component({
  selector: 'app-suporte-geral-list',
  templateUrl: './suporte-geral-list.component.html',
  styleUrls: ['./suporte-geral-list.component.scss']
})
export class SuporteGeralListComponent extends BaseFormComponent<MensagemUsuario> implements OnInit, OnDestroy {
	
	listColumns: ColumnsTable[] = [
		{id:'nome_entidade', name: 'Cliente', title: 'Cliente', class: '', type: 'string'},
		{id:'pergunta', name: 'Pergunta', title: 'Pergunta', class: '', type: 'string'},
		{id:'nome_usuario_pergunta', name: 'Usuário', title: 'Usuário', class: '', type: 'string'},
		{id:'suporte_respondido', name: 'Respondido', title: 'Respondido', class: '', type: 'boolean'},
  	];
	data: MensagemUsuario[] = [ ];
	listActions: ActionTable[] = [];
	filterForm: FilterTable[] = [
		{key: 'pergunta', value: '', type: 'string', class: 'col-12 col-md-6', label: 'Pergunta'},
		{key: 'nome_usuario_pergunta', value: '', type: 'string', class: 'col-12 col-md-6', label: 'Usuário'},
		{key: 'suporte_respondido', value: null, type: 'select', class: 'col-12 col-md-6', label: 'Respondido', options: Ativo}
	];
	filters: any;

	constructor(
		public myServices: SuporteGeralService,
		public activatedRoute: ActivatedRoute,
	) {
		super(activatedRoute);
	}

	ngOnDestroy(): void {
		this.unsubscribeList();
	}

	ngOnInit() {
		this.loading();
		this.get();
	}

	get(): void {
		this.myServices.findAll().subscribe({
			next: (res) => {
				this.data = res;
				this.loaded();
			},
			error: (error) => {
				this.loaded();
				this.msgError(error?.error?.message ?? "Ocorreu um erro interno")
			},
		});
	}

}